'use client';

import { type User, onIdTokenChanged } from 'firebase/auth';
import { Observable, defer } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { auth } from '../firebase/auth';

/**
 * Observable view of the current Firebase auth user, including
 * silent token refreshes (we use `onIdTokenChanged`, not
 * `onAuthStateChanged`, so the value also re-emits every time the
 * Firebase SDK refreshes the JWT in the background).
 *
 * Replayed (1) so late subscribers see the current user without
 * waiting for the next auth event.
 */
export const authState$: Observable<User | null> = defer(
  () =>
    new Observable<User | null>(subscriber => {
      const unsubscribe = onIdTokenChanged(auth(), {
        next: value => subscriber.next(value),
        error: err => subscriber.error(err),
        complete: () => subscriber.complete(),
      });
      return { unsubscribe };
    }),
).pipe(shareReplay({ bufferSize: 1, refCount: false }));
